/**
 * Report a tap on any phone number to Plausible.
 *
 * Without a contact form the telephone is the site's only conversion path, and
 * the number appears in three places -- the footer, the Kontakt page and the
 * sticky call button on mobile. One delegated listener covers all three and
 * keeps the count honest when a fourth appears.
 *
 * Deliberately NOT Plausible's class-based tagging (`plausible-event-name=...`).
 * That needs a feature toggle in the Plausible dashboard which nothing in this
 * repo can verify, and it would only tag whichever element carries the class.
 *
 * Nothing here is load-bearing. The links are plain `<a href="tel:">` and work
 * with this file deleted; `window.plausible` is absent on every host but the
 * live one, because the tag is host-gated in the `analytics` snippet.
 */

export function initAnalytics (root = document) {
  root.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href^="tel:"]')
    if (!link) return

    window.plausible?.('phone tapped')
  })
}
